import { authEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { ForgotPasswordRequestType, MessageResponseType } from "@/types";

export const forgotPasswordHandler = async ({ email }: ForgotPasswordRequestType): Promise<MessageResponseType> => {
    const response = await axiosClient.post<MessageResponseType>(
        authEndpoints.forgotPassword,
        { email },
    );

    return { message: response.data.message };
};
